fx.ns("repositories", class ThemeCollectionRepository extends fx.ModelArray {

    constructor()
    {
        super([]);

        this.endpoint = "/app/themes";

        this._tags = [];
    }

    load()
    {
        this.post( {  action:"collection" },  this._loaded);
    }

    _loaded(data)
    {
        if (data.error)
        {
            this.event("theme-collection-load-error", data);
        }
        else
        {
            this.addItem(data);
            this.event("theme-collection-loaded");
        }
    }

});